module.exports = __webpack_public_path__ + "img/border_trapezoid.820d992d.svg";